@import '~@union-investment/global-resources/src/styles/solid-design-system';

:host {
  display: block;

  sd-button {
    margin: $sd-spacing-4 $sd-spacing-0 $sd-spacing-0 $sd-spacing-5;

    &:first-of-type {
      margin-left: $sd-spacing-0;
    }
  }

  h4 {
    margin: $sd-spacing-0;
  }

  .error {
    color: $sd-textColor-error;
    font-size: $sd-fontSize-base;
    line-height: $sd-lineHeight-normal;
    font-weight: $sd-fontWeight-bold;
  }
}
